import { translateOrFirst } from '@/utils/locales';
import * as paseto from '@/utils/paseto';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['body', 'template', 'error'];

  // Keep track of pending requests to avoid rendering with stale data when the
  // component is disconnected and connected again before the request completes.
  #load;

  async connect() {
    const load = (this.#load = this.#fetchDoors());

    try {
      const body = await load;
      if (this.#load !== load) return;

      this.#renderRows(body.data || []);
    } catch (error) {
      if (this.#load !== load) return;

      console.error('Acture Fit: could not load the doors', error);
      this.errorTarget.hidden = false;
    }
  }

  disconnect() {
    this.#load = undefined;
  }

  async #fetchDoors() {
    const { dataUrl } = this.bodyTarget.dataset;

    const response = await paseto.fetch(dataUrl, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(await response.text());

    return response.json();
  }

  #renderRows(doors) {
    const format = new Intl.NumberFormat(document.documentElement.lang);

    this.bodyTarget.replaceChildren(
      ...doors.map((door) => {
        const row = this.templateTarget.content
          .querySelector('tr')
          .cloneNode(true);
        const cells = row.querySelectorAll('td');

        cells[0].textContent = translateOrFirst(door.title) ?? '';
        cells[1].textContent = format.format(door.page_views);
        cells[2].textContent = format.format(door.visitors);

        return row;
      }),
    );
  }
}
